export default {
  Core_Domain_Settings_Clicked_Add_Domain: 'Core_Domain_Settings_Clicked_Add_Domain',
  Core_Domain_Settings_Clicked_Kebab_Menu: 'Core_Domain_Settings_Clicked_Kebab_Menu',
  Core_Domain_Settings_Clicked_Setup_Box: 'Core_Domain_Settings_Clicked_Setup_Box',
  Core_Domain_Settings_Typed_Domain: 'Core_Domain_Settings_Typed_Domain',
  Core_Domain_Settings_Received_Domain_Confirmation_Error:
    'Core_Domain_Settings_Received_Domain_Confirmation_Error',
  Core_Domain_Settings_Clicked_Add_Domain_Confirmation_Button:
    'Core_Domain_Settings_Clicked_Add_Domain_Confirmation_Button',
  Core_Domain_Settings_Clicked_Add_Domain_Confirmation:
    'Core_Domain_Settings_Clicked_Add_Domain_Confirmation',
  Core_Domain_Settings_Clicked_Setup_Domain: 'Core_Domain_Settings_Clicked_Setup_Domain',
  Core_Domain_Setup_Modal_Typed_SubDomain: 'Core_Domain_Setup_Modal_Typed_SubDomain',
  Core_Domain_Setup_Modal_Clicked_Save_Domain: 'Core_Domain_Setup_Modal_Clicked_Save_Domain',
  Core_Domain_Setup_Modal_Clicked_Exit_Popup_Modal:
    'Core_Domain_Setup_Modal_Clicked_Exit_Popup_Modal',
  Core_Domain_Setup_Modal_Clicked_Check_DNS_Configuration:
    'Core_Domain_Setup_Modal_Clicked_Check_DNS_Configuration',
  Core_Domain_Setup_Modal_Clicked_Closed_DNS_Configuration:
    'Core_Domain_Setup_Modal_Clicked_Closed_DNS_Configuration',
  Core_Domain_Settings_Clicked_Pop_Up_Modal_Cancel_Button:
    'Core_Domain_Settings_Clicked_Pop_Up_Modal_Cancel_Button',
  Core_Domain_Settings_Clicked_Pop_Up_Modal_Confirm_Button:
    'Core_Domain_Settings_Clicked_Pop_Up_Modal_Confirm_Button',
  Core_Domain_Settings_Typed_Subdomain: 'Core_Domain_Settings_Typed_Subdomain',
  Core_Domain_Settings_Subdomain_Type: 'Core_Domain_Settings_Subdomain_Type',
  Core_Domain_Settings_Clicked_Create_Subdomain_Button:
    'Core_Domain_Settings_Clicked_Create_Subdomain_Button',
  Core_Domain_Settings_Clicked_Cancel_Subdomain_Button:
    'Core_Domain_Settings_Clicked_Cancel_Subdomain_Button',
  Core_Domain_Settings_Clicked_Restore_Domain: 'Core_Domain_Settings_Clicked_Restore_Domain',
  Core_Domain_Settings_Selected_Team: 'Core_Domain_Settings_Selected_Team',
  Core_Domain_Settings_Clicked_Save_Team_Selection_Button:
    'Core_Domain_Settings_Clicked_Save_Team_Selection_Button',
  Core_Domain_Settings_Clicked_Share_with_Everyone_Box:
    'Core_Domain_Settings_Clicked_Share_with_Everyone_Box',
  Core_Global_Selected_Subdomain: 'Core_Global_Selected_Subdomain',
  Core_Global_Clicked_Save_Domain: 'Core_Global_Clicked_Save_Domain',
  Core_Global_Confirm_Subdomain_Change_Button: 'Core_Global_Confirm_Subdomain_Change_Button',
  Core_Global_Clicked_Cancel_Subdomain_Change_Button:
    'Core_Global_Clicked_Cancel_Subdomain_Change_Button',
  Core_Domain_Settings_Clicked_FAQ: 'Core_Domain_Settings_Clicked_FAQ',
  Core_Domain_Settings_Clicked_Add_Subdomain: 'Core_Domain_Settings_Clicked_Add_Subdomain'
}
